import { environmentBase } from './environment-base';

export const environment = {
  ...environmentBase,
  timeoutInMins: 15,
  languageSelectorEnabled: true
};
